import { print } from "graphql";
import {
  LearningLlmStreamDocument,
  LearningLlmStreamSubscription,
  LearningLlmStreamSubscriptionVariables,
} from "@axio/graphql/generated/graphql";
import { createGraphqlSseClient } from "./graphqlSseClient";

export type LearningLlmStreamEvent = NonNullable<LearningLlmStreamSubscription["learningLlmStream"]>;

type StreamHandlers = {
  onChunk?: (event: LearningLlmStreamEvent) => void;
  onComplete?: () => void;
  onError?: (error: Error) => void;
};

const LEARNING_LLM_STREAM_SUBSCRIPTION = print(LearningLlmStreamDocument);

const { startStream, cancelStream } = createGraphqlSseClient<
  LearningLlmStreamEvent,
  LearningLlmStreamSubscriptionVariables
>({
  operationName: "LearningLlmStream",
  query: LEARNING_LLM_STREAM_SUBSCRIPTION,
  getPayload: (parsed) => parsed?.data?.learningLlmStream as LearningLlmStreamEvent | undefined,
  logPrefix: "learningGraphqlSseClient",
});

export const cancelLearningLlmStream = () => {
  cancelStream();
};

export const startLearningLlmStream = async (
  question: string,
  controller: AbortController,
  handlers: StreamHandlers = {},
  options?: Omit<LearningLlmStreamSubscriptionVariables, "question">
) => {
  await startStream({ question, ...options }, controller, handlers);
};
